import { useSelector } from "src/redux/store";
import IsRole from "src/utils/IsRole";
import Roles from "src/utils/Roles";

export const useClaims = () => {
  const { claims } = useSelector((state) => state.authJwt);

  // Detección de sesión web PERSONAL de un empleado. El backend emite
  // el JWT con la identidad del RESTAURANTE padre (no del empleado),
  // así que `claims.role` no sirve para distinguir — la marca real la
  // pone el thunk `login` en localStorage cuando `res.data.employeeId`
  // llega poblado. Casos que devuelven true:
  //   • Login web con email+password de un empleado.
  //   • Verify OTP tras registro/QR de empleado.
  // Casos que devuelven false: admin dueño, TPV compartido con empleado
  // identificado por kiosko, franquiciados, distribuidor, global admin.
  const isEmployeeWebSession = (() => {
    try {
      return window.localStorage.getItem("SessionKind") === "employee-web";
    } catch { return false; }
  })();

  return {
    isAdmin: IsRole(claims.role, Roles.GLOBAL_ADMIN),
    isUserNormal: IsRole(claims.role, Roles.USER_NORMAL),
    isUserNormalPro: IsRole(claims.role, Roles.USER_NORMAL_PRO),
    isUserEmployee: IsRole(claims.role, Roles.USER_EMPLOYEE),
    isUserEmployeePro: IsRole(claims.role, Roles.USER_EMPLOYEE_PRO),
    isUserPayment: IsRole(claims.role, Roles.USER_PAYMENT),
    isUserNotPayment: IsRole(claims.role, Roles.USER_NOT_PAYMENT),
    isUserDistributor: IsRole(claims.role, Roles.USER_DISTRIBUTOR),
    isEmployeeWebSession,

    userCanCreateLicences: IsRole(claims.role, Roles.USER_CAN_CREATE_LICENCES),
    userCanEditLicences: IsRole(claims.role, Roles.USER_CAN_EDIT_LICENCES),
    userCanDeleteLicences: IsRole(claims.role, Roles.USER_CAN_DELETE_LICENCES),
    userCanDuplicateLicences: IsRole(
      claims.role,
      Roles.USER_CAN_DUPLICATE_LICENCES,
    ),
  };
};
